import React, { useEffect } from 'react'
import { Box, styled } from '@mui/material'
import { Icon } from 'packages/eid-icons'

const Container = styled(Box)({
    paddingRight: '1.9rem',
    marginBottom: '1.5rem',
    position: 'fixed',
    zIndex: '9999999',
    background: '#00000063',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100vh',
})

const ThirdPartyCookies = styled(Box)({
    background: '#f7f8fa',
    maxWidth: '76rem',
    width: '100%',
    borderRadius: '0.5rem',
    padding: '4rem',
})

const ThirdPartyCookiesHeader = styled(Box)({
    paddingBottom: '4rem',
    borderBottom: '0.1rem solid #d8d8d8',
    display: 'flex',
    '& h2': {
        fontSize: '2.4rem',
        fontWeight: '500',
        margin: 0,
        marginLeft: '1.5rem',
        '& span': {
            fontWeight: '700',
        },
    },
})

const ThirdPartyCookieBody = styled(Box)({
    marginTop: '3rem',
    '& p': {
        fontSize: '1.8rem',
        margin: '0',
        '& span': {
            fontWeight: '700',
        },
    },
})

const OrderList = styled('div')({
    marginTop: '2.5rem',
    fontSize: '1.6rem',
    lineHeight: '2rem',
    display: 'flex',
    '& span': {
        fontWeight: '700',
    },
    '& label': {
        color: '#0057A0',
        marginRight: '0.4rem',
    },
})

const CookiesButton = styled('button')({
    background: '#0057A0',
    border: 'solid 0.1rem #0057A0',
    borderRadius: '0.6rem',
    padding: '1.4rem 2.4rem',
    marginTop: '4rem',
    fontSize: '1.6rem',
    color: '#fff',
    cursor: 'pointer',
})

const CookieEnableModal = ({ bannerData, handleAccpet }) => {
    useEffect(() => {
        document.body.classList.add('cookiesModal-open')

        return () => document.body.classList.remove('cookiesModal-open')
    }, [])

    return (
        <Container>
            <ThirdPartyCookies>
                <ThirdPartyCookiesHeader>
                    {bannerData?.iconName && (
                        <Icon name={bannerData.iconName} height={40} width={40} />
                    )}
                    <h2
                        dangerouslySetInnerHTML={{ __html: bannerData?.title }}
                    />
                </ThirdPartyCookiesHeader>
                <ThirdPartyCookieBody>
                    <p
                        dangerouslySetInnerHTML={{
                            __html: bannerData?.subTitle,
                        }}
                    />
                    {bannerData?.items?.length
                        ? bannerData.items.map((item, index) => (
                              <OrderList key={index}>
                                  <label>{index + 1}. </label>
                                  <div
                                      dangerouslySetInnerHTML={{ __html: item }}
                                  ></div>
                              </OrderList>
                          ))
                        : null}
                    <CookiesButton onClick={() => handleAccpet()}>
                        {bannerData?.btnLabel}
                    </CookiesButton>
                </ThirdPartyCookieBody>
            </ThirdPartyCookies>
        </Container>
    )
}

export default CookieEnableModal
